import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as Notification from '../../components/Common/notification'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import TextField from '@material-ui/core/TextField'
import { Row, Col } from 'react-flexbox-grid'
import Button from '@material-ui/core/Button'
import CurrencyFormat from 'react-currency-format'
import 'react-anything-sortable/sortable.css'
import './styles.css';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';
import MenuItem from '@material-ui/core/MenuItem'
import DragAndDrop from '../Common/dragAndDrop'
import Checkbox from '@material-ui/core/Checkbox'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress';
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import { stateToHTML } from 'draft-js-export-html';
import CropperModal from '../CropperModal'
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        //padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        //margin: theme.spacing(0.5),
    },
});

class ArticuloGenericoNuevo extends React.Component {
    renderButtons = () => {
        return (
            <div>

                <Button variant="contained" className="btnSecundario" onClick={this.props.handleOnCancel}>CANCELAR</Button>
                <Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnSave}>GUARDAR</Button>

            </div>
        )
    }


    //Los drag son para arrastrar las imagenes y cambiar el orden

    dragStart(e) {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.dragged);
    }
    dragEnd(e) {
        // update state
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over);

        if (from !== to && to !== -1 && this.over !== undefined) {
            if (this.props.canSwap === false) { return; }

            e.target.parentElement.style.borderColor = "" //le saco los bordes
            e.target.parentElement.style.borderWidth = "1px"

            this.overaux.lastChild.lastElementChild.style.borderColor = "";
            this.overaux.lastChild.lastElementChild.style.borderWidth = "1px"

            this.props.handleOnChangeOrderArticuloImagenes(from - 1, to - 1) // ya que utilizaremos los indices del array de imagenes

        }
        else {
            Notification.showError('Error al arrastrar. Intente nuevamente.')
            e.target.parentElement.style.borderColor = "" //le saco los bordes
            e.target.parentElement.style.borderWidth = "1px"
        }
    }
    dragOver(e) {
        e.preventDefault();

        if (e.target.className === 'placeholder') return;
        if (e.target.parentElement.parentElement.parentElement.dataset.id) {

            this.over = e.target.parentElement.parentElement.parentElement.dataset.id;
            this.overaux = e.target.parentElement.parentElement.parentElement;

            e.target.parentElement.style.borderColor = "cyan"
            e.target.parentElement.style.borderWidth = "3px"

        }
    }


    constructor(props) {
        super(props)

        this.state = {
            editorState: EditorState.createEmpty(), // Editor para la descripcion
            subrubroClear: true, // Para que al principio el subrubro no tenga indice.
            update: false
        };

        this.etiquetaInput = React.createRef();
        this.alternativaInput = React.createRef();
        this.caracteristicaInput = React.createRef();
    }

    onEditorStateChange = (editorState) => {

        let auxiliar = editorState.getCurrentContent()
        let html = stateToHTML(auxiliar)
        this.props.handleOnDescripcion(html)
        this.setState({
            editorState
        })
    }

    onEditorStateClear = () => {

        let editor = EditorState.createEmpty()
        this.setState({
            editorState: editor
        })
        this.props.onChangeFalseEditorState()
    }

    handleOnSubrubro = (e) => {
        this.setState({
            subrubroClear: false
        })
        this.props.handleOnSubrubro(e)
    }


    componentWillReceiveProps = (props) => {
        if (props.clearState && this.state.update === false) {
            this.onEditorStateClear()
            this.setState({
                update: true
            })
        }
    }

    handleOnAddEtiqueta = () => {
        this.props.handleOnAddEtiqueta();
        let txt = this.etiquetaInput
        txt.current.focus();
    }

    // nuevo

    handleOnAddAlternativa = () => {
        this.props.handleOnAddAlternativa();
        let txt = this.alternativaInput
        txt.current.focus();
    }

    handleOnAddCaracteristica = () => {
        this.props.handleOnAddCaracteristica();
        this.caracteristicaInput.current.value = '';
        this.caracteristicaInput.current.focus();
    }

    handleOnChangeOferta = (event) => {
        const { handleOfertaChange } = this.props;
        handleOfertaChange(event.target.value);
    }

    handleDatosExtraChange = (event) => {
        const { handleDatosExtraChange } = this.props;
        handleDatosExtraChange(event);
    }

    handleCaracteristicasProductoChange = (event) => {
        const { handleCaracteristicasProductoChange } = this.props;
        handleCaracteristicasProductoChange(event);
    }


    handleEditorChange = (editorState) => {
        this.setState({ editorState });
    };

    handleProductoPesableChange = (event) => {
        const { handleProductoPesableChange } = this.props;
        handleProductoPesableChange(event);
    }

    handleIncrementoChange = (event) => {
        const { handleIncrementoChange } = this.props;
        handleIncrementoChange(event);
    }

    handleCantidadMinimaChange = (event) => {
        const { handleCantidadMinimaChange } = this.props;
        handleCantidadMinimaChange(event);
    }

    handleCantidadMaximaChange = (event) => {
        const { handleCantidadMaximaChange } = this.props;
        handleCantidadMaximaChange(event);
    }

    handleMarcaChange = (event) => {
        const { handleMarcaChange } = this.props;
        handleMarcaChange(event.target.value);
    };

    handleProveedorChange = (event) => {
        const { handleProveedorChange } = this.props;
        handleProveedorChange(event.target.value);
    };

    handleOnCodigoBarra = (event) => {
        const { handleOnCodigoBarra } = this.props;
        handleOnCodigoBarra(event);
    }

    render() {
        const { editorState } = this.state;

        const classes = this.props;

        const { marcas, proveedor, ofertas, errorDescription, articulo, rubros, handleOnNombre, handleOnSubrubro, match } = this.props;
        const { handleOnDropFile, handleCheckboxChange, handleEliminarImagenArticulo, handleOnOpenCropperModal, openModalImagen, imagenOriginal, handleOnCloseCropperModal, handleOnSaveImagenCortada } = this.props;
        const { handleOnChangePrecio,
            handleOnChangePrecioPromocional, handleOnChangePorcentajeImpuestosNacionales} = this.props;
        const selectedOferta = articulo.oferta ? articulo.oferta.idOferta : '';


        // Validación para stock disponible
        let handleKeyPress = (event) => {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);

            // Expresión regular para permitir solo números
            const invalidCharsRegex = /[^0-9]/;

            if (invalidCharsRegex.test(keyValue)) {
                event.preventDefault();
            }
        };

        return (
            <div className='articuloCreateEdit'>
                <TitleBar
                    title={this.props.esEdicion ? 'Edición Artículo' : 'Nuevo Artículo'}
                    type='createArticulo'
                    showSearch={false}
                    buttons={this.renderButtons()}
                />
                <Paper className="paperArticulo" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Articulo y Descripción
                            </Typography>
                            <Row>
                                <Col md={6}>
                                    <TextField
                                        required
                                        id="articulo"
                                        label="Articulo"
                                        error={!!errorDescription.errorNombre}
                                        helperText={errorDescription.errorNombre || ''}
                                        style={{ width: '100%' }}
                                        value={articulo.nombre}
                                        margin="normal"
                                        onChange={handleOnNombre}
                                    />
                                </Col>
                                <Col md={6}>
                                    <TextField
                                        id="marca"
                                        select
                                        required
                                        error={!!errorDescription.errorMarca}
                                        helperText={errorDescription.errorMarca || ''}
                                        label="Marca"
                                        style={{ width: '100%' }}
                                        margin="normal"
                                        value={articulo.marca.idMarca}
                                        onChange={(event) => this.handleMarcaChange(event)}
                                        InputLabelProps={{ shrink: !!articulo.marca.idMarca }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                    >
                                        {marcas.map((option) => (
                                            <MenuItem key={option.idMarca} value={option.idMarca}>
                                                {`${option.codigo}`}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '10px' }}>
                                <Col md={6}>
                                    <TextField
                                        id="proveedor"
                                        select
                                        label="Proveedor"
                                        value={articulo.proveedor.idProveedor || ''}
                                        style={{ width: '100%' }}
                                        onChange={(event) => this.handleProveedorChange(event)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}
                                    >
                                        {proveedor.map((option) => (
                                            <MenuItem key={option.idProveedor} value={option.idProveedor}>
                                                {`${option.codigo} - ${option.nombreProveedor}`}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Col>
                            </Row>

                            <Row style={{ marginTop: '20px' }}>
                                <Col md={12}>
                                    <div className="clsEditor">
                                        <Editor
                                            editorState={editorState}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            onEditorStateChange={this.handleEditorChange}
                                            toolbar={{
                                                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'remove', 'history'],
                                            }}
                                            placeholder='Descripción'
                                            editorStyle={{ paddingLeft: '15px', minHeight: '200px', border: '1px solid #F1F1F1' }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperFotos" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Fotos
                            </Typography>
                            <DragAndDrop
                                style={{ marginBottom: '5px' }}
                                data-id='-1'
                                accept='image/jpeg, image/png'
                                message='Arrastra las imágenes o'
                                handleOnDrop={handleOnDropFile}
                                multiple={true}
                            />
                            <Paper onDragOver={this.dragOver}>
                                <Row style={{ backgroundColor: 'white' }}>
                                    {articulo.imgSrc.map((c, i) => {
                                        return (
                                            <Col style={{ height: '250px', width: '250px' }} key={i} className='imagenArticuloContainer' md={3} data-id={c.orden} draggable='true' onDragEnd={this.dragEnd} onDragStart={this.dragStart}>
                                                <div>
                                                    <Checkbox className='check' onChange={(e) => handleCheckboxChange(i, e)} value={c.selected} checked={c.selected} />
                                                    <div>
                                                        <PopupState variant="popover" popupId="demo-popup-menu">
                                                            {popupState => (
                                                                <React.Fragment>
                                                                    <IconButton className='iconMenu' {...bindTrigger(popupState)}>
                                                                        <MoreVertIcon />
                                                                    </IconButton>
                                                                    <Menu {...bindMenu(popupState)}>
                                                                        <MenuItem onClick={() => handleEliminarImagenArticulo(i)}>Eliminar</MenuItem>
                                                                    </Menu>
                                                                </React.Fragment>
                                                            )}
                                                        </PopupState>
                                                    </div>
                                                    <div className='imageContainer' style={{ height: '250px', width: '250px', border: '1px solid #F1F1F1', padding: '5px' }}>
                                                        {c !== undefined ?
                                                            <img 
                                                                onClick={() => handleOnOpenCropperModal(c)} 
                                                                src={
                                                                    c.pathImagen 
                                                                        ? c.pathImagen
                                                                        : c.imagen
                                                                            ? `data:image/ief;base64,${c.imagen}`
                                                                            : ''
                                                                } 
                                                                className='imagenArticulo' 
                                                                alt="Articulo" 
                                                            />
                                                            :
                                                            <div>
                                                                <CircularProgress />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Paper>

                            {/* CROPPER PARA IMAGENES ARTÍCULO */}
                            {openModalImagen &&
                                <CropperModal
                                    ratio={2 / 3}
                                    src={imagenOriginal}
                                    handleOnCloseCropperModal={handleOnCloseCropperModal}
                                    handleOnSaveImagenCortada={handleOnSaveImagenCortada}
                                    open={openModalImagen}
                                    modalArticulo={true}
                                />
                            }
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperPrecios" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Precios
                            </Typography>
                            <Row style={{ marginTop: '20px', backgroundColor: 'white' }}>
                                <Col md={6}>
                                    <CurrencyFormat
                                        required
                                        className='currencyInput'
                                        customInput={TextField}
                                        label="Precio de venta"
                                        style={{ width: '100%', marginTop: '15px', textAlign: 'right' }}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        allowNegative={false}
                                        decimalSeparator=","
                                        thousandSeparator="."
                                        prefix={'$'}
                                        error={!!errorDescription.errorPrecio}
                                        helperText={errorDescription.errorPrecio || ''}
                                        value={articulo.precio}
                                        onValueChange={handleOnChangePrecio}
                                    />
                                </Col>
                                <Col md={6}>
                                    <CurrencyFormat
                                        className='currencyInput'
                                        customInput={TextField}
                                        label="Precio Promocional"
                                        style={{ width: '100%', marginTop: '15px', textAlign: 'right' }}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        allowNegative={false}
                                        decimalSeparator=","
                                        thousandSeparator="."
                                        prefix={'$'}
                                        error={!!errorDescription.errorPrecio}
                                        helperText={errorDescription.errorPrecio || ''}
                                        value={articulo.precioPromocional}
                                        onValueChange={handleOnChangePrecioPromocional}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '20px', backgroundColor: 'white' }}>
                                <Col md={6}>
                                    <CurrencyFormat
                                        required
                                        className='currencyInput'
                                        customInput={TextField}
                                        label="Porcentaje Impuestos nacionales"
                                        style={{ width: '100%', marginTop: '15px', textAlign: 'right' }}
                                        decimalScale={0}
                                        fixedDecimalScale={true}
                                        allowNegative={false}
                                        decimalSeparator=","
                                        thousandSeparator="."
                                        prefix={'%'}
                                        error={!!errorDescription.errorPorcentajeImpuestosNacionales}
                                        helperText={errorDescription.errorPorcentajeImpuestosNacionales || ''}
                                        value={articulo.porcentajeImpuestosNacionales || 0}
                                        onValueChange={handleOnChangePorcentajeImpuestosNacionales}
                                    />
                                </Col>
                                <Col md={6}>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperCodigos" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Códigos
                            </Typography>
                            <Row style={{ marginTop: '20px', backgroundColor: 'white' }}>
                                <Col md={6}>
                                    <TextField
                                        id="codigoInterno"
                                        label="SKU"
                                        style={{ width: '100%' }}
                                        margin="normal"
                                        value={this.props.articulo.codigoInterno}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ]*$/.test(value)) {
                                                this.props.handleOnCodigoInterno(e);
                                            }
                                        }}
                                    />

                                </Col>
                                <Col md={6}>
                                    <TextField
                                        id="codigoBarra"
                                        label="Código de barras"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[0-9]*$/.test(value)) {
                                                this.props.handleOnCodigoBarra(e);
                                            }
                                        }}
                                        style={{ width: '100%' }}
                                        margin="normal"
                                        value={this.props.articulo.codigoBarra}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            maxLength: 13,
                                        }}
                                    />
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperCategorias" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Categorías
                            </Typography>
                            <Row style={{ marginTop: '20px' }}>
                                <Col md={6}>
                                    <TextField
                                        id="subrubro"
                                        select
                                        required
                                        error={!!errorDescription.errorSubrubro}
                                        helperText={errorDescription.errorSubrubro || ''}
                                        label="Subrubro"
                                        value={articulo.idSubrubro}
                                        onChange={handleOnSubrubro}
                                        style={{ width: '100%' }}
                                        margin="normal"
                                    >
                                        {rubros.subrubros !== undefined ? rubros.subrubros.map((e) => {
                                            return (
                                                e.idRubro.toString() === match.params.idRubro &&
                                                <MenuItem key={e.idSubrubro} value={e.idSubrubro}>
                                                    {e.nombre}
                                                </MenuItem>
                                            );
                                        }) : ''}
                                    </TextField>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperConfiguracionVenta" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Tipo de venta
                            </Typography>
                            <div style={{ marginTop: '20px' }}>
                                <Row>
                                    <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                        {/* Checkbox para saber si es pesable */}
                                        <Checkbox
                                            className='esPesable'
                                            id="esPesableCheckbox"
                                            checked={articulo.productoPesable}
                                            onChange={this.handleProductoPesableChange}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                        <label for='esPesableCheckbox' >¿Es pesable?</label>
                                    </Col>
                                    {articulo.productoPesable && (

                                        <Col md={6}>
                                            {/* Incremento */}
                                            <TextField
                                                id="incremento"
                                                label="Incremento"
                                                style={{ width: '100%' }}
                                                margin="normal"
                                                value={articulo.incremento}
                                                inputProps={{
                                                    min: 1,
                                                    max: 10,
                                                    maxLength: 10,
                                                }}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^[0-9]*[.,]?[0-9]*$/.test(value)) {
                                                        this.handleIncrementoChange(e);
                                                    }
                                                }}
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </div>


                            <div>
                                <Row >
                                    <Col md={6}>
                                        {/* Cantidad mínima */}
                                        <TextField
                                            id="cantidadMinima"
                                            label="Cantidad Mínima"
                                            style={{ width: '100%' }}
                                            margin="normal"
                                            value={articulo.cantidadLimMin}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: 0,
                                                max: 10,
                                                maxLength: 10,
                                            }}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^[0-9]*[.,]?[0-9]*$/.test(value)) {
                                                    this.handleCantidadMinimaChange(e);
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        {/* Cantidad máxima */}
                                        <TextField
                                            id="cantidadMaxima"
                                            label="Cantidad Máxima"
                                            style={{ width: '100%' }}
                                            margin="normal"
                                            value={articulo.cantidadLimMax}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: 0,
                                                max: 10,
                                                maxLength: 10,
                                            }}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^[0-9]*[.,]?[0-9]*$/.test(value)) {
                                                    this.handleCantidadMaximaChange(e);
                                                }
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperOfertas" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Ofertas
                            </Typography>
                            <Row style={{ marginTop: '20px', backgroundColor: 'white' }}>
                                <Col md={12}>
                                    <FormControl style={{ width: '100%' }}>
                                        <Select
                                            labelId="oferta-label"
                                            id="oferta"
                                            value={selectedOferta}
                                            onChange={this.handleOnChangeOferta}
                                            displayEmpty
                                        >
                                            <MenuItem value="">
                                                <em>Anidar tipo de oferta a este producto</em>
                                            </MenuItem>
                                            {ofertas.map((oferta) => (
                                                <MenuItem key={oferta.idOferta} value={oferta.idOferta}>
                                                    {oferta.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperConfiguracionesAdicionales" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Configuraciones adicionales
                            </Typography>
                            <Row>
                                {/* Datos extras */}
                                <Col md={6}>
                                    <TextField
                                        id="datosExtra"
                                        label="Datos extras"
                                        style={{ width: '100%' }}
                                        margin="normal"
                                        value={articulo.datosExtra}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ.,\s]*$/.test(value)) {
                                                this.handleDatosExtraChange(e);
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                {/* Articulo Alternativas */}
                                <Col md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <TextField
                                            id="alternativa"
                                            label="Opciones"
                                            style={{ width: '100%' }}
                                            margin="normal"
                                            value={this.props.campoAlternativa}
                                            inputRef={this.alternativaInput}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ.,\s]*$/.test(value)) {
                                                    this.props.handleOnCampoAlternativa(e);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.handleOnAddAlternativa();
                                                }
                                            }}
                                        />
                                        <IconButton
                                            style={{ cursor: 'pointer', color: 'black', marginRight: '4px', marginTop: '6px' }}
                                            onClick={this.handleOnAddAlternativa}
                                        >
                                            <AddCircleOutlineIcon />
                                        </IconButton>
                                    </div>
                                </Col>
                                <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                    {/* Chips para mostrar las alternativas */}
                                    <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap' }}>
                                        {articulo.articuloAlternativa.map((alternativa, index) => (
                                            <Chip
                                                clickable
                                                key={index}
                                                color="primary"
                                                label={alternativa.alternativa}
                                                style={{ marginRight: '10px', marginBottom: '10px' }}
                                                onDelete={() => this.props.handleDeleteAlternativa(alternativa.alternativa)}

                                            />
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                {/* Características*/}
                                <Col md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <TextField
                                            id="caracteristicasProducto"
                                            label="Características del producto"
                                            style={{ width: '100%' }}
                                            margin="normal"
                                            value={this.props.campoCaracteristica}
                                            inputRef={this.caracteristicaInput}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ.,\s]*$/.test(value)) {
                                                    this.props.handleOnCampoCaracteristica(e);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.handleOnAddCaracteristica();
                                                }
                                            }}
                                        />
                                        <IconButton
                                            style={{ cursor: 'pointer', color: 'black', marginRight: '4px', marginTop: '6px' }}
                                            onClick={this.handleOnAddCaracteristica}
                                        >
                                            <AddCircleOutlineIcon />
                                        </IconButton>
                                    </div>
                                </Col>
                                <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
                                    {/* Chips para mostrar las características del producto */}
                                    <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap' }}>
                                            {articulo.articuloFiltro.map((caracteristica, index) => (
                                                <Chip
                                                    clickable
                                                    key={index}
                                                    color="secondary"
                                                    label={caracteristica.filtro}
                                                    style={{ marginRight: '10px', marginBottom: '10px' }}
                                                    onDelete={() => this.props.handleDeleteCaracteristica(caracteristica.filtro)}
                                                />
                                            ))}
                                    </div>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperEtiquetas" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">Tags y SEO</Typography>
                            <Row>
                                <Col md={6} style={{ display: 'flex', alignItems: 'baseline' }}>
                                    <TextField
                                        id="etiqueta"
                                        label="Etiqueta"
                                        style={{ width: '95%' }}
                                        margin="normal"
                                        value={this.props.campoEtiqueta}
                                        inputRef={this.etiquetaInput}
                                        onChange={this.props.handleOnCampoEtiqueta}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                this.handleOnAddEtiqueta();
                                            }
                                        }}
                                    >
                                    </TextField>
                                    <AddCircleOutlineIcon
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.handleOnAddEtiqueta}
                                    />
                                </Col>

                                <Col md={6} >
                                    <ul className='campoEtiquetas'>
                                        {this.props.articulo && this.props.articulo.etiquetas && this.props.articulo.etiquetas.map((data, index) => {
                                            return (
                                                <li key={index}>
                                                    <Chip
                                                        label={data.etiqueta}
                                                        clickable
                                                        color="primary"
                                                        classes={{ root: classes.chip }}
                                                        className='etiqueta'
                                                        onDelete={data.etiquetaManual === true ? () => this.props.handleDelete(data.etiqueta) : undefined}
                                                    />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>

                <Paper className="paperStock" style={{ marginBottom: '20px' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">Cantidad</Typography>
                            <Row>
                                <Col md={6} >

                                    <TextField
                                        required
                                        id="stock"
                                        label="Stock disponible"
                                        onKeyPress={handleKeyPress}
                                        style={{ width: '100%' }}
                                        margin="normal"
                                        value={this.props.articulo.stockGenerico}
                                        onChange={this.props.handleOnStock}
                                    >
                                    </TextField>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>
                </Paper>



                {/* CROPPER PARA IMAGENES ARTÍCULO */}
                {this.props.openModalImagen &&
                    <CropperModal
                        ratio={2 / 3}
                        src={this.props.imagenOriginal}
                        handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
                        handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
                        open={this.props.openModalImagen}
                        modalArticulo={true}
                    />
                }

            </div>
        )
    }
}


ArticuloGenericoNuevo.propTypes = {
    articulo: PropTypes.object.isRequired,
    rubros: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    handleOnNombre: PropTypes.func.isRequired,
    handleOnPrecio: PropTypes.func.isRequired,
    handleOnCodigoInterno: PropTypes.func.isRequired,
    handleOnSubrubro: PropTypes.func.isRequired,
    handleOnStock: PropTypes.func.isRequired,
    handleOnDropFile: PropTypes.func.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    handleEliminarImagenArticulo: PropTypes.func.isRequired,
    handleOnOpenCropperModal: PropTypes.func.isRequired,
    handleOnCloseCropperModal: PropTypes.func.isRequired,
    handleOnChangeOrderArticuloImagenes: PropTypes.func.isRequired,
    handleOnDescripcion: PropTypes.func.isRequired,
    handleMarcaChange: PropTypes.func.isRequired,
    handleProveedorChange: PropTypes.func.isRequired,
    handleOfertaChange: PropTypes.func.isRequired,
    handleOnChangePrecioPromocional: PropTypes.func.isRequired,
    handleOnChangePorcentajeImpuestosNacionales: PropTypes.func.isRequired,
    handleOnChangeOferta: PropTypes.func.isRequired,
    handleDatosExtraChange: PropTypes.func.isRequired,
    handleCaracteristicasProductoChange: PropTypes.func.isRequired,
    handleProductoPesableChange: PropTypes.func.isRequired,
    handleIncrementoChange: PropTypes.func.isRequired,
    handleCantidadMinimaChange: PropTypes.func.isRequired,
    handleCantidadMaximaChange: PropTypes.func.isRequired,
    handleOnCodigoBarra: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    handleDelete: PropTypes.func,
    handleDeleteAlternativa: PropTypes.func,
    handleDeleteCaracteristica : PropTypes.func,
    handleOnCampoEtiqueta: PropTypes.func.isRequired,
    handleOnAddEtiqueta: PropTypes.func.isRequired,
    handleOnAddAlternativa: PropTypes.func.isRequired,
    handleOnAddCaracteristica: PropTypes.func.isRequired,
    articuloEdicion: PropTypes.object,
    esEdicion: PropTypes.bool.isRequired,
    clearState: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    errorDescription: PropTypes.object.isRequired,
    onChangeFalseEditorState: PropTypes.func.isRequired,
    openModalImagen: PropTypes.bool.isRequired,
    imagenOriginal: PropTypes.object.isRequired,
    handleOnSaveImagenCortada: PropTypes.func.isRequired,
    ofertas: PropTypes.array.isRequired
};

ArticuloGenericoNuevo.defaultProps = {
    handleDelete: () => { },
    handleDeleteAlternativa: () => { },
    handleDeleteCaracteristica: () => { },
    articuloEdicion: null
};

export default withStyles(styles)(ArticuloGenericoNuevo)